import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import './Participant.css';

export default function CompletionPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session');
  const { getSession } = useApp();
  const [analysisReady, setAnalysisReady] = useState(false);

  useEffect(() => {
    // تحقق كل ثانيتين إذا اكتمل التحليل
    const interval = setInterval(() => {
      const session = getSession(sessionId);
      if (session?.analysis) {
        setAnalysisReady(true);
        clearInterval(interval);
      }
    }, 2000);
    // توقف بعد دقيقتين
    setTimeout(() => clearInterval(interval), 120000);
    return () => clearInterval(interval);
  }, [sessionId]);

  return (
    <div className="participant-bg">
      <div className="p-card animate-in" style={{ textAlign: 'center' }}>
        <div className="complete-icon">✓</div>
        <div className="confetti">
          {['#FFC200','#3D2000','#1D9E75','#E24B4A','#FFC200','#3D2000'].map((c, i) => (
            <div key={i} className="confetti-dot" style={{ background: c }} />
          ))}
        </div>

        <h1 className="p-title" style={{ textAlign: 'center' }}>شكراً جزيلاً! 🎉</h1>
        <p className="p-desc" style={{ textAlign: 'center' }}>
          تم إرسال إجاباتك بنجاح. مشاركتك تساعدنا في تحسين تجربة الطلب.
        </p>

        <div className="session-badge">
          <div style={{ fontSize: '11px', color: 'var(--brown-muted)', marginBottom: '4px' }}>رقم جلستك</div>
          <div className="session-num">#{sessionId || 'INT-0000'}</div>
        </div>

        {!analysisReady ? (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontSize: '12px', color: 'var(--brown-muted)', marginTop: '0.75rem' }}>
            <div className="spinner" style={{ width: '14px', height: '14px', borderWidth: '2px' }} />
            جاري تحليل إجاباتك...
          </div>
        ) : (
          <div style={{ fontSize: '12px', color: 'var(--green-text)', marginTop: '0.75rem' }}>
            ✓ تم تحليل إجاباتك بنجاح
          </div>
        )}

        <p style={{ fontSize: '13px', color: 'var(--brown-muted)', marginTop: '1rem' }}>
          يمكنك الآن إغلاق هذه النافذة بأمان
        </p>
      </div>
    </div>
  );
}
